
























































import Vue from 'vue'
import { mapGetters } from 'vuex'
import TableWithFilter from './TableWithFilter.vue'
import ReimbursementDetailModal from './ReimbursementDetailModal.vue'
import { ReimbursementService } from '@/api/services/reimbursements'
import { OrganizationService } from '@/api/services/organizations'

export default Vue.extend({
  components: { TableWithFilter, ReimbursementDetailModal },

  data() {
    return {
      rows: [] as any[],
      organizations: [] as any[],
      loading: false,
      filters: {} as any,
      selected: null as any,
      columns: [
        { label: 'Bénéficiaire', field: 'beneficiaryName' },
        { label: 'Payé par', field: 'payerPhone' },
        { label: 'Montant', field: 'amount', currency: true },
        { label: 'Date', field: 'createdAt' },
        { label: 'Statut', field: 'state' },
        { label: 'Action', field: '_actions', align: 'left' }
      ]
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),

    isFnm(): boolean {
      return !!(
        this.user &&
        this.user.organization &&
        this.user.organization.isFnm
      )
    },

    filterData(this: any): any[] {
      const data: any[] = [
        {
          title: 'Statut',
          model: 'status',
          items: [
            { label: 'Tous les statuts', value: '' },
            { label: 'Succès', value: 'paid' },
            { label: 'En attente', value: 'pending' },
            { label: 'Échec', value: 'failed' }
          ]
        }
      ]
      if (this.isFnm) {
        data.unshift({
          title: 'SFD',
          model: 'organizationId',
          items: [{ label: 'Tous les SFDs', value: '' }, ...this.organizations]
        })
      }
      return data
    }
  },

  async mounted(this: any) {
    if (this.isFnm) {
      try {
        this.organizations = (await OrganizationService.findAllSfds()).map(
          (organization: any) => ({
            label: organization.name,
            value: organization.id
          })
        )
      } catch (error) {
        console.error(error)
      }
    }
    await this.load()
  },

  methods: {
    async load(this: any) {
      this.loading = true
      try {
        const response = await ReimbursementService.findAll(
          { page: 1, perPage: 1000 },
          this.filters
        )
        this.rows = (response.result || []).map((reimbursement: any) => ({
          id: reimbursement.id,
          beneficiaryName: reimbursement.beneficiary
            ? reimbursement.beneficiary.name
            : '',
          payerPhone: reimbursement.payerPhone,
          amount: reimbursement.amount,
          createdAt: reimbursement.createdAt,
          state: reimbursement.state,
          transaction: reimbursement.transaction,
          beneficiary: reimbursement.beneficiary
        }))
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    onFilter(this: any, data: any) {
      this.filters = {
        status: data.status || '',
        organizationId: data.organizationId || '',
        from: data.dateDebut || '',
        to: data.dateFin || '',
        search: data.search || ''
      }
      this.load()
    },

    openDetail(this: any, item: any) {
      this.selected = item
    },

    closeDetail(this: any) {
      this.selected = null
    },

    onResynced(this: any) {
      this.load()
    },

    statusLabel(state: string): string {
      if (state === 'paid') return 'Succès'
      if (state === 'failed') return 'Échec'
      return 'En attente'
    },
    statusBgClass(state: string): string {
      if (state === 'paid') return 'bg-green-100'
      if (state === 'failed') return 'bg-red-100'
      return 'bg-yellow-200'
    },
    statusDotClass(state: string): string {
      if (state === 'paid') return 'bg-secondary'
      if (state === 'failed') return 'bg-danger'
      return 'bg-yellow-600'
    },
    statusTextClass(state: string): string {
      if (state === 'paid') return 'text-green-500'
      if (state === 'failed') return 'text-danger'
      return 'text-yellow-600'
    }
  }
})
